import React from "react";
import { useState } from "react";
import { motion } from "framer-motion";

export default function ReportCard({
  image,
  title,
  description,
  moreInfo,
  file,
}) {
  const [collapse, setCollapse] = useState(false);

  return (
    <div className="card p-3" style={{ background: "#F9F9F9" }}>
      <div className=" d-flex flex-row w-100 gap-4" style={{ height: "12rem" }}>
        <div className="w-100" style={{ flex: 1 }}>
          <img
            src={image}
            class={`card-img-top rounded`}
            alt="..."
            style={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
        </div>
        <div className="d-flex flex-column w-100" style={{ flex: 1 }}>
          <div className="h-100">
            <h5
              className="card-title fw-bold text-primary"
              style={{ fontSize: "1rem" }}
            >
              {title}
            </h5>
            <p className="card-text" style={{ fontSize: ".8rem" }}>
              {description}
            </p>
          </div>
          <button
            className="btn btn-link fw-semibold p-0 m-0"
            style={{ fontSize: ".9rem", width: "fit-content" }}
            onClick={() => setCollapse(!collapse)}
          >
            {collapse ? "See Less" : "See more"}
            {collapse ? (
              <i class="bi bi-chevron-up ps-1"></i>
            ) : (
              <i class="bi bi-chevron-down ps-1"></i>
            )}
          </button>
        </div>
      </div>
      {collapse ? (
        <motion.div
          animate={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: -30 }}
        >
          <hr className="w-100" />
          <div className="pt-3 d-flex flex-column gap-2">
            {moreInfo.description ? (
              <div>
                {moreInfo.description.map((info) => {
                  return (
                    <p key={info} style={{ fontSize: ".9rem" }}>
                      {info}
                    </p>
                  );
                })}
              </div>
            ) : null}
            <h5 className="fw-bold text-primary">{moreInfo.subtitle}</h5>
            <ul className="d-flex flex-column gap-1">
              {moreInfo.list.map((item) => {
                return <li key={item}>{item}</li>;
              })}
            </ul>
            <a href={file} download={title}>
              {moreInfo.buttonLabel ? (
                <button
                  className="btn btn-primary ps-3 pe-3 pt-2 pb-2 rounded"
                  style={{ width: "fit-content" }}
                >
                  {moreInfo.buttonLabel}
                </button>
              ) : null}
            </a>
          </div>
        </motion.div>
      ) : null}
    </div>
  );
}
